module.exports = __webpack_public_path__ + "static/media/informazioni.b8278f94.svg";